import React from 'react';
import Logo from 'components/Logo';
import Link from 'gatsby-link';

export default class Head extends React.Component {
  constructor() {
    super();

    this.state = {
      toggle: false,
    };
  }

  // eslint-disable-next-line
  componentDidMount() {
    $('#navbarBurger').click(() => {
      $('#navMenuIndex').toggleClass('is-active');
    });
  }

  // eslint-disable-next-line
  render() {
    const styles = {
      display: this.state.toggle ? 'inline' : 'none',
    };

    return (
      <div className={`navbar-wrapper navbar-fade navbar-light ${this.state.toggle ? 'mobile-menu-dark' : null}`}>
        <div className="hero-head">
          <div className="container">
            <nav className="nav">
              <div className="container big">
                <div className="nav-left" style={{ overflow: 'visible' }}>
                  <Link className="next-nav-logo" to="/">
                    <Logo width="80" />
                  </Link>
                  <Link to="/why-us" className="nav-item is-tab nav-inner is-not-mobile">
                    Why Us
                  </Link>
                  <Link to="/how-we-work" className="nav-item is-tab nav-inner is-not-mobile">
                    How we work
                  </Link>

                  <div className="nav-item is-tab nav-inner is-drop is-hoverable is-right is-hidden-mobile">
                    <span className="navbar-link">Capabilities </span>
                    <i className="fas fa-angle-down is-icon-xs" />
                    <div className="dropContain">
                      <div className="dropOut">
                        <ul>
                          <Link to="/capabilities/progressive-web-apps">
                            <li>
                              <i className="drop-icon fas fa-mobile-alt" /> Progressive Web Apps
                            </li>
                          </Link>
                          <Link to="/capabilities/serverless">
                            <li>
                              <i className="drop-icon fas fa-server" /> Serverless
                            </li>
                          </Link>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="nav-item is-tab nav-inner is-drop is-hoverable is-right is-hidden-mobile">
                    <span className="navbar-link">Technologies</span>
                    <i className="fas fa-angle-down is-icon-xs" />
                    <div className="dropContain">
                      <div className="dropOut">
                        <ul>
                          <Link to="/technologies/angular-js">
                            <li>
                              <i className="drop-icon fab fa-angular" /> AngularJS
                            </li>
                          </Link>

                          <Link to="/technologies/react-js">
                            <li>
                              <i className="drop-icon fab fa-react" /> ReactJS
                            </li>
                          </Link>

                          <Link to="/technologies/node-js">
                            <li>
                              <i className="drop-icon fab fa-node-js" /> NodeJS
                            </li>
                          </Link>

                          <Link to="/technologies/django">
                            <li>
                              <i className="drop-icon fab fa-python" /> Django
                            </li>
                          </Link>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <span className="nav-toggle" onClick={() => this.setState({ toggle: !this.state.toggle })}>
                  <span />
                  <span />
                  <span />
                </span>
                <div className={`nav-right nav-menu ${this.state.toggle ? 'is-active' : null}`} style={styles}>
                  <Link to="/why-us" className="nav-item is-tab nav-inner is-menu-mobile">
                    Why Us
                  </Link>
                  <Link to="how-we-work" className="nav-item is-tab nav-inner is-menu-mobile">
                    How we work
                  </Link>

                  <div to="capabilities" className="nav-item is-tab nav-inner is-menu-mobile">
                    <input id="nav-item-section-state-capabilities-switcher" className="nav-item-section-state" type="checkbox" />
                    <div className="nav-item-section">
                      <label className="nav-item-section-label" htmlFor="nav-item-section-state-capabilities-switcher">
                        <h3 className="nav-item-section-title">
                          Capabilities <i className="fas fa-angle-down is-icon-xs" />
                        </h3>
                      </label>
                      <ul className="nav-item-section-list ul-list-reset">
                        <li className="nav-list-item">
                          <Link to="/capabilities/progressive-web-apps" className="nav-item-link">
                            <i className="drop-icon fas fa-mobile-alt" /> Progressive Web Apps
                          </Link>
                        </li>
                        <li className="nav-list-item">
                          <Link to="/capabilities/serverless" className="nav-item-link">
                            <i className="drop-icon fas fa-server" /> Serverless
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div to="technologies" className="nav-item is-tab nav-inner is-menu-mobile">
                    <input id="nav-item-section-state-technologies-switcher" className="nav-item-section-state" type="checkbox" />
                    <div className="nav-item-section">
                      <label className="nav-item-section-label" htmlFor="nav-item-section-state-technologies-switcher">
                        <h3 className="nav-item-section-title">
                          Technologies <i className="fas fa-angle-down is-icon-xs" />
                        </h3>
                      </label>
                      <ul className="nav-item-section-list ul-list-reset">
                        <li className="nav-list-item">
                          <Link to="/technologies/angular-js" className="nav-item-link">
                            <i className="drop-icon fas fa-mobile-alt" /> AngularJS
                          </Link>
                        </li>
                        <li className="nav-list-item">
                          <Link to="/technologies/django" className="nav-item-link">
                            <i className="drop-icon fas fa-server" /> Django
                          </Link>
                        </li>
                        <li className="nav-list-item">
                          <Link to="/technologies/node-js" className="nav-item-link">
                            <i className="drop-icon fas fa-server" /> NodeJS
                          </Link>
                        </li>
                        <li className="nav-list-item">
                          <Link to="/technologies/react-js" className="nav-item-link">
                            <i className="drop-icon fas fa-server" /> ReactJS
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* <Link to="technologies" className="nav-item is-tab nav-inner is-menu-mobile">
                    Technologies
                  </Link> */}
                  <span className="nav-item cta-container">
                    <a id="#signup-btn" href="landing-signup.html" className="button button-signup btn-outlined is-bold btn-align light-btn rounded">
                      Let&apos;s build together
                    </a>
                  </span>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Head.jsx